module.exports = __webpack_public_path__ + "img/album23_08.d69734d1.jpg";